// extracted by mini-css-extract-plugin
export var equalColumn = "_gf-0";